<template>
    <select class="form-control">
        <slot></slot>
    </select>
</template>

<script>

import Vue from 'vue';

export default {

    name: 'select2',

    props: ['options', 'value'],

    mounted() {

        this.init();

    },

    methods: {

        init() {
            // update options
            $(this.$el)
                .empty()
                .select2({ data: this.options })
                .val(this.value)
                .trigger('change')
                .on('change', ({currentTarget}) => {
                    this.$emit('input', currentTarget.value);
                    this.$emit('change', currentTarget.value);
                });
        }

    },

    watch: {
        value() {
            // update value
            $(this.$el).off().select2('destroy');
            this.init();
        },
        options() {
            this.init()
        }        
    },

    destroyed() {
        $(this.$el).off().select2('destroy');
    }
}
</script>
